import React from 'react'
import { SampleUser } from '../../assests/ExportImageIcon'

const BlogCard = ({ blog }) => (
    <div className='slidePart'>
        <img src={blog.img} alt={blog.title} />
        <div className='blogTitle'>{blog.title}</div>
        <div className='blogAuthor'><img src={blog.authorImage || SampleUser} alt={blog.author} /> {blog.author} | {blog.date}</div>
    </div>
)

export default BlogCard
